import { render, staticRenderFns } from "./EditModal.vue?vue&type=template&id=499cab54&scoped=true&"
import script from "./EditModal.vue?vue&type=script&lang=js&"
export * from "./EditModal.vue?vue&type=script&lang=js&"
import style0 from "./EditModal.vue?vue&type=style&index=0&id=499cab54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499cab54",
  null
  
)

export default component.exports